import { setupListKeyboardNavigation } from "./listKeyboardNavigation.js";
import { defineComponent, resolveComponent, createBlock, openBlock, mergeProps, createSlots, renderList, withCtx, renderSlot, normalizeProps, guardReactiveProps } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const ESCAPE_KEY = "Escape";
const nextFrame = () => {
  return new Promise(
    (resolve) => requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    })
  );
};
const _sfc_main = defineComponent({
  name: "PDropdown",
  inheritAttrs: false,
  props: {
    /**
     * Enables navigation for `.dropdown-item` using the up/down keys.
     * This can be set to false when we're creating a generic popover.
     */
    enableArrowNavigation: {
      type: Boolean,
      default: true
    },
    /**
     * Enables closing the dropdown with the Escape key.
     */
    enableCloseOnEsc: {
      type: Boolean,
      default: true
    },
    /**
     * v-tooltip wraps the popper trigger with a div that has `display: inline-block` set by default.
     * This prop is used to override the CSS style of that wrapper div
     */
    triggerStyle: {
      type: Object,
      default: () => ({
        display: "inline-block"
      })
    }
  },
  data() {
    return {
      defaultAttrs: {
        triggers: ["click"],
        autoHide: true,
        theme: "p-dropdown-theme",
        popperClass: "dropdown",
        placement: "bottom-start",
        distance: 4,
        delay: 0,
        handleResize: true
      },
      navigationSvc: null,
      prevReference: null
    };
  },
  mounted() {
    Object.assign(this.$refs.vPopper.$refs.popper.$el.style, this.triggerStyle);
  },
  beforeUnmount() {
    this.destroy();
  },
  methods: {
    onShow() {
      if (this.enableArrowNavigation) {
        if (this.navigationSvc) {
          this.navigationSvc.init();
        } else {
          this.navigationSvc = setupListKeyboardNavigation({
            itemContainer: this.$refs.vPopper.$refs.popperContent.$el
          });
        }
      }
      this.enableCloseOnEsc && document.addEventListener("keydown", this.popoverEscKeydown);
    },
    popoverEscKeydown(e) {
      e.key === ESCAPE_KEY && this.$refs.vPopper.$refs.popper.hide();
    },
    destroy() {
      var _a;
      (_a = this.navigationSvc) == null ? void 0 : _a.destroy();
      document.removeEventListener("keydown", this.popoverEscKeydown);
    },
    async updateReference(newReference) {
      if (!newReference) {
        throw Error("Reference element is required");
      }
      const popper = this.$refs.vPopper.$refs.popper;
      if (popper) {
        popper.$_detachPopperNode();
        if (popper.isShown) {
          popper.$emit("update:shown", false);
          if (newReference === this.prevReference) {
            return;
          }
        }
        await nextFrame();
        popper.$_referenceNode = newReference;
        this.prevReference = newReference;
        await nextFrame();
        popper.$emit("update:shown", true);
      }
    }
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VDropdown = resolveComponent("VDropdown");
  return openBlock(), createBlock(_component_VDropdown, mergeProps({ ref: "vPopper" }, { ..._ctx.defaultAttrs, ..._ctx.$attrs }, {
    onShow: _ctx.onShow,
    onHide: _ctx.destroy
  }), createSlots({ _: 2 }, [
    renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: withCtx((scope) => [
          renderSlot(_ctx.$slots, slot, normalizeProps(guardReactiveProps(scope || {})))
        ])
      };
    })
  ]), 1040, ["onShow", "onHide"]);
}
const PDropdown = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  PDropdown as default
};
